import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { Publisher } from '../model/publisher.class';
import { Media } from '../model/media.class';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'app-publisher-media',
    templateUrl: './publisher.media.component.html'
})
export class PublisherMediaComponent implements OnInit {

    @Input() publisherId;

    medias: Media[];
    columns: Array<any> = [
        {
            title: 'Media ID',
            name: 'mid',
            sort: 'desc'
        },
        {
            title: 'Cover',
            name: 'coverUrl',
            sort: ''
        },
        {
            title: 'Titel',
            name: 'title',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Titel filtern' }
        },
        {
            title: 'Autor',
            name: 'author',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Autor filtern' }
        },
        {
            title: 'Medientyp',
            name: 'mediaType',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Medientyp filtern' }
        },
        {
            title: 'Medienstatus',
            name: 'mediaStatus',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Medienstatus filtern' }
        },
        {
            title: 'ISBN',
            name: 'isbn',
            sort: '',
        },
        {
            title: 'EAN',
            name: 'ean',
            sort: '',
        },
        {
            title: 'Erscheinungsdatum',
            name: 'publishDate',
            sort: '',
            pipe: 'date'
        },
        {
            title: 'Zuletzt geändert',
            name: 'lasModificationDate',
            sort: '',
            pipe: 'dateTime'
        }
    ];

    constructor(public userService: UserService) { }

    ngOnInit() {
        if (this.publisherId) {
            this.userService.getBy('media', this.publisherId, 'publisher').subscribe(data => {
                this.medias = data as Media[];
                // Display the coverurl as an img tag
                for (let i = 0; i < this.medias.length; i++) {
                    const coverUrl = this.userService.determineImageUrl(this.medias[i]);
                    this.medias[i].coverUrl = ' <img src="' + coverUrl + '" height="42" width="42"> ';
                }
            });
        } else {
            this.userService.getAll('media').subscribe(data => this.medias = data as Media[]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherMedia/publisher.media.component.ts